import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {setCurrentStep, submitOwnershipTransfer, setCurrentPopUp, setShowPopUp} from '../OwnershipTransferBuyerSlice';
import {OwnershipTransferCustomerStep, PopupEnum, PopupMessageContent, ServiceType} from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PaymentCG from '../../SaleBlock/PaymentCG/PaymentCG';
import {cgTypeEnum} from '../../../../utilities/enums/cgTypeEnum';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText} from '../Reports/dwhReports';

const PaymentData = (props) => {
  const [showErrorMsg, setShowErrorMsg] = useState(false);

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: {...props.data, userDetails: props.userDetails},
        actionType: DwhActionType.PaymentMethodPage,
        messageText: DWHMessageText.PaymentMethodPageDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, []);

  useEffect(() => {
    if (props.data.simResponsibilities) {
      submitTransfer();
      props.setShowPopUp(false);
    }
  }, [props.data.simResponsibilities]);

  const submitTransfer = () => {
    dwhGeneralReport({
      data: {...props.data, userDetails: props.userDetails},
      actionType: DwhActionType.PaymentMethodPage,
      messageText: DWHMessageText.PaymentMethodPageButtonClicked,
      status: DWHStatus.Ongoing,
    });
    const transferReq = {
      OrderId: props.data.orderId,
      CollaborationApproval: props.data.collaborationApproval,
      OfferId: props.data.serviceType == ServiceType.Cellular ? props.data.selectedPricePlan.offerID : '',
      SelectedAddress: {
        CityName: props.data.buyerAddress.city,
        StreetName: props.data.buyerAddress.street,
        PostalCode: props.data.buyerAddress.zipCode,
        AptNumber: props.data.buyerAddress.apartmentNum,
        HouseNumber: props.data.buyerAddress.houseNum,
      },
      PersonalInfo: {
        PaymentCcToken: props.paymentCg.CCToken,
        PaymentCardDueYear: props.paymentCg.form.CardDueYear,
        PaymentCardDueMonth: props.paymentCg.form.CardDueMonth,
        PaymentCcType: props.paymentCg.CCType,
        FirstName: props.data.buyerPersonalData.firstName,
        LastName: props.data.buyerPersonalData.lastName,
        EMail: props.data.buyerPersonalData.email,
      },
    };
    props.submitOwnershipTransfer(transferReq);
  };

  const nextStep = () => {
    if (!props.paymentCg.CCToken) {
      setShowErrorMsg(true);
    } else {
      setShowErrorMsg(false);
      if (props.data.serviceType == ServiceType.Cellular) {
        //open Popup
        props.setCurrentPopUp({
          currentPopupData: PopupMessageContent.SimResponsibilities,
          currentPopUp: PopupEnum.MessagePopup,
        });
      } else {
        submitTransfer();
      }
    }
  };

  return (
    <div className='ownership-transfer-form '>
      <div className='l-title center'>מהו אמצעי התשלום?</div>
      <div className='m-title center'>אנחנו צריכים אותו כדי לפתוח לך חשבון</div>
      <div>
        <PaymentCG
          isHideTermsCheckbox
          padding='0'
          paymentRequestedQuantity={9}
          noLoader
          type={cgTypeEnum.CHECKCARD}
          isShowIdNumber={true}
          customerId={props.userDetails.magicLinkParameters.idNumber}
          source="OwnershipTransferPrivateBuyerBlock"
        />
      </div>
      <div className='continue-button'>
        {showErrorMsg && <div className='error center'>יש להשלים את פרטי התשלום</div>}
        <BtnSubmit onclick={() => nextStep()} text={'אישור וסיום'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateBuyer,
  paymentCg: state.PaymentCG,
  userDetails: state.authentication?.loginData,
});

const mapDispatchToProps = {
  setCurrentStep,
  submitOwnershipTransfer,
  setShowPopUp,
  setCurrentPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentData);
